export function createEventParticipantsPanelProps({
  hasConciergeParticipants = false,
  participantCounts = {},
  effectiveGroupEvents = [],
  adminParticipants = [],
  conciergeParticipants = [],
  artistParticipantsByPart = [],
  participantPartScopeTabs = [],
  participantPartScopeEventUuid = 'all',
  onChangeParticipantPartScope,
  setProfileTarget,
  membersVisible = true,
  hiddenArtistsText = '参加メンバー決定後公開',
}) {
  return {
    hasConciergeParticipants,
    participantCounts,
    effectiveGroupEventCount: Array.isArray(effectiveGroupEvents)
      ? effectiveGroupEvents.length
      : 0,
    adminParticipants,
    conciergeParticipants,
    artistParticipantsByPart,
    participantPartScopeTabs,
    participantPartScopeEventUuid,
    onChangeParticipantPartScope,
    membersVisible,
    hiddenArtistsText,
    onSelectAdmin: (payload) => setProfileTarget?.({ type: 'admin', payload }),
    onSelectConcierge: (payload) => setProfileTarget?.({ type: 'artist', payload }),
    onSelectArtist: (payload) => setProfileTarget?.({ type: 'artist', payload }),
  };
}
